import React from 'react';
import Checkbox from '@mui/material/Checkbox';

interface CustomCheckboxProps {
  checked?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement> | { target: { checked: boolean } }) => void;
  disabled?: boolean;
  className?: string;
  [key: string]: any;
}

const CustomCheckbox: React.FC<CustomCheckboxProps> = React.memo(({ 
  checked = false, 
  onChange, 
  disabled = false,
  className = "",
  ...other 
}) => {
  const handleClick = () => {
    if (!disabled && onChange) {
      // Create a synthetic event object that mimics the structure expected by onChange
      const syntheticEvent = {
        target: {
          checked: !checked
        }
      };
      onChange(syntheticEvent);
    }
  };

  return (
    <div className={`custom-checkbox-wrapper ${className}`}>
      <Checkbox 
        checked={!!checked} 
        onChange={onChange}
        disabled={disabled}
        sx={{
          display: 'none'
        }}
        {...other}
      />
      <div 
        className={`custom-checkbox ${checked ? 'checked' : ''} ${disabled ? 'disabled' : ''}`}
        onClick={handleClick}
        style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
      >
        {checked && (
          <svg 
            className="check-icon" 
            width="16" 
            height="16" 
            viewBox="0 0 24 24" 
            fill="none"
          >
            <path 
              d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" 
              fill="currentColor"
            />
          </svg>
        )}
      </div>
    </div>
  );
});

CustomCheckbox.displayName = 'CustomCheckbox';

export default CustomCheckbox; 